import React from 'react';
import { Search, X } from 'lucide-react';

export const CustomerSelector = ({
  customerSearch, handleCustomerSearchChange, handleCustomerFocus,
  showCustomerDropdown, searchingCustomers, customerResults,
  handleSelectCustomer, handleClearCustomer, selectedCustomer,
  customer, setCustomer, dropdownRef
}) => (
  <div className="bg-card p-6 rounded-lg border border-border">
    <h3 className="text-lg font-semibold mb-4">Customer</h3>
    <div className="space-y-3">
      <div className="relative" ref={dropdownRef}>
        <div className="relative">
          <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-muted-foreground" />
          <input type="text" placeholder="Search or type customer name..."
            value={customerSearch} onChange={handleCustomerSearchChange} onFocus={handleCustomerFocus}
            className="w-full pl-9 pr-8 py-2 border border-input rounded-md" data-testid="customer-search-input" />
          {customerSearch && (
            <button onClick={handleClearCustomer}
              className="absolute right-2 top-1/2 transform -translate-y-1/2 p-1 text-muted-foreground hover:text-foreground">
              <X className="h-3.5 w-3.5" />
            </button>
          )}
        </div>

        {showCustomerDropdown && (
          <div className="absolute top-full left-0 right-0 mt-1 bg-card border border-border rounded-md shadow-lg z-50 max-h-60 overflow-y-auto" data-testid="customer-dropdown">
            {searchingCustomers ? (
              <div className="p-3 text-sm text-muted-foreground text-center">Searching...</div>
            ) : customerResults.length > 0 ? (
              customerResults.map((c) => (
                <button key={c.id} onClick={() => handleSelectCustomer(c)}
                  className={`w-full text-left px-3 py-2.5 hover:bg-muted transition-colors border-b border-border last:border-b-0 ${c.credit_denied ? 'bg-red-50/50' : ''}`}>
                  <div className="flex items-center justify-between">
                    <p className="font-medium text-sm">{c.name}</p>
                    <div className="flex items-center gap-1.5">
                      {c.credit_denied && (
                        <span className="text-xs px-1.5 py-0.5 bg-red-100 text-red-700 rounded font-bold">CREDIT DENIED</span>
                      )}
                      {c.pricing_scheme === 'pwo' && (
                        <span className="text-xs px-1.5 py-0.5 bg-amber-100 text-amber-700 rounded">PW OIL</span>
                      )}
                      {c.tax_exempt && (
                        <span className="text-xs px-1.5 py-0.5 bg-green-100 text-green-700 rounded">Exempt</span>
                      )}
                    </div>
                  </div>
                  {(c.email || c.phone) && (
                    <p className="text-xs text-muted-foreground mt-0.5">{[c.email, c.phone].filter(Boolean).join(' . ')}</p>
                  )}
                </button>
              ))
            ) : (
              <div className="p-3 text-sm text-muted-foreground text-center">
                {customerSearch ? 'No customers found' : 'No customers yet'}
              </div>
            )}
          </div>
        )}
      </div>

      {selectedCustomer && (
        <div className="px-3 py-2 bg-muted rounded-md text-sm" data-testid="selected-customer-info">
          <div className="flex items-center justify-between">
            <p className="font-medium">{selectedCustomer.name}</p>
            <div className="flex items-center gap-1.5">
              {selectedCustomer.pricing_scheme === 'pwo' ? (
                <span className="text-xs px-1.5 py-0.5 bg-amber-100 text-amber-700 rounded font-medium">PW OIL Price</span>
              ) : (
                <span className="text-xs px-1.5 py-0.5 bg-blue-100 text-blue-700 rounded font-medium">Regular Price</span>
              )}
              {selectedCustomer.tax_exempt && (
                <span className="text-xs px-1.5 py-0.5 bg-green-100 text-green-700 rounded font-medium">Tax Exempt</span>
              )}
              {selectedCustomer.approved === false && (
                <span className="text-xs px-1.5 py-0.5 bg-red-100 text-red-700 rounded font-medium">Credit Denied</span>
              )}
            </div>
          </div>
        </div>
      )}

      <input type="email" placeholder="Email" value={customer.email}
        onChange={(e) => setCustomer({ ...customer, email: e.target.value })}
        className="w-full px-3 py-2 border border-input rounded-md" data-testid="customer-email-input" />
      <input type="tel" placeholder="Phone" value={customer.phone}
        onChange={(e) => setCustomer({ ...customer, phone: e.target.value })}
        className="w-full px-3 py-2 border border-input rounded-md" data-testid="customer-phone-input" />
    </div>
  </div>
);
